import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
  },
  
  spinner: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
  },
  
  circle: {
    width: '60px',
    height: '60px',
    border: '4px solid var(--gray-200)',
    borderTop: '4px solid var(--primary-main)',
    borderRadius: '50%',
    animation: '$spin 1s linear infinite',
    
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '4px',
      left: '4px',
      right: '4px',
      bottom: '4px',
      border: '2px solid transparent',
      borderTop: '2px solid var(--accent-teal)',
      borderRadius: '50%',
      animation: '$spin 0.8s linear infinite reverse',
    },
  },
  
  text: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '1.125rem',
    fontWeight: 500,
    color: 'var(--gray-600)',
    textAlign: 'center',
    letterSpacing: '0.5px',
    
    '& .brand': {
      background: 'linear-gradient(135deg, var(--primary-main) 0%, var(--secondary-main) 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 700,
    },
  },
  
  dots: {
    display: 'flex',
    gap: '8px',
    marginTop: '1rem',
    
    '& span': {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      background: 'var(--accent-teal)',
      animation: '$bounce 1.4s ease-in-out infinite both',
      
      '&:nth-child(1)': {
        animationDelay: '-0.32s',
      },
      '&:nth-child(2)': {
        animationDelay: '-0.16s',
      },
    },
  },
  
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  
  '@keyframes bounce': {
    '0%, 80%, 100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1)',
    },
  },
  
  fadeOut: {
    opacity: 0,
    transition: 'opacity 0.5s ease-out',
    pointerEvents: 'none',
  },
});

const ModernLoader = ({ isLoading = true, text = "Laden..." }) => {
  const classes = useStyles();
  
  if (!isLoading) return null;
  
  return (
    <div className={`${classes.loader} ${!isLoading ? classes.fadeOut : ''}`}>
      <div className={classes.spinner}>
        <div className={classes.circle}></div>
        <div className={classes.text}>
          <span className="brand">Mt-Partner</span> wordt geladen...
        </div>
        <div className={classes.dots}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default ModernLoader;